import { IExperiment } from '../../types/experiments';

export function getExperiment(experiments: IExperiment[], experimentName: string): IExperiment | undefined {
  return experiments.find(o => o.experimentName === experimentName);
}

export function isExperimentActive(experiments: IExperiment[], experimentName: string, groupName: string): boolean {
  const experiment = getExperiment(experiments, experimentName);

  if (!experiment) {
    return false;
  }

  return experiment.groupName === groupName;
}
